import {createContext} from 'react';
import {EventWizardPresentation} from '@Components/event-wizard/event-wizard.types';

/** How the wizard is shown, for the few components that branch on it. Read it through `useIsEventWizardEmbedded()`. */
export const EVENT_WIZARD_PRESENTATION_CONTEXT = createContext<EventWizardPresentation>(EventWizardPresentation.PAGE);
